import React from 'react';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import { applyStyles } from 'util/helpers';
import Colors from 'constants/colors';
import BlockHeader from 'components/common/BlockHeader';
import i18n from 'i18n';
import AboutHeader from './AboutHeader';

const About = ({ className }) => (
  <div className={className}>
    {i18n.t('faq:about', { returnObjects: true }).map((about, i) => (
      <div key={i} className="about-box">
        <a className="anchor" id={`link-${i}`}>
          #
        </a>
        <BlockHeader>{about.header}</BlockHeader>
        {about.feqs && (
          <div>
            {about.feqs.map((feq, j) => (
              <AboutHeader
                key={`${i}${j}`}
                name={feq.name}
                content={feq.content}
                detail={feq.detail}
              />
            ))}
          </div>
        )}
      </div>
    ))}
  </div>
);

const commonStyle = css`
  .about-box {
    position: relative;
    border-bottom: 1px solid ${Colors.gray2};

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }

    a.anchor {
      position: absolute;
      display: block;
      height: 0;
      overflow: hidden;
    }
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  .about-box {
    padding-bottom: 48px;

    a.anchor {
      top: -170px;
    }

    ${BlockHeader} {
      margin-top: 66px;
    }
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  .about-box {
    padding-bottom: 8px;

    a.anchor {
      top: -80px;
    }

    ${BlockHeader} {
      margin-top: 28px;
    }
  }
`;

export default applyStyles(About)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/Faq/components/About.js